<!-- Start Page Title Area -->
<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>最新消息</h2>
        </div>
    </div>
</div>
<!-- End Page Title Area -->

<!-- Start Blog Area -->
<section class="blog-area ptb-100">
    <div class="container" style="max-width: 80%">
        <div class="row">
            <ng-container *ngFor="let news of newsList">
                <div class="col-lg-4 col-md-6">
                    <div class="single-blog-post">
                        <div class="entry-thumbnail">
                            <a [href]="news.link"><img [src]="news.image" alt="image" /></a>
                        </div>

                        <div class="entry-post-content">
                            <div class="entry-meta">
                                <ul>
                                    <li>{{ news.date }}</li>
                                </ul>
                            </div>
                            <h3>
                                <a [href]="news.link" [innerHTML]="news.title"></a>
                            </h3>
                            <p [innerHTML]="news.description"></p>
                            <a [href]="news.link" class="read-more-btn">Read More <i class="flaticon-add-1"></i></a>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</section>
<!-- End Blog Area -->
